import request from "utils/request";
import requestJWT from "utils/requestJWT";
import axios from "axios";
import ShowToast from "utils/ShowToast";
import { baseURLApi } from "utils/index"

const loginApi = async (formData) => {
  return await request.post(`/account/login`, formData);
};

const getInfoApi = async () => {
  return await requestJWT.get(`/account/me`);
};


const registerApi = async (formData) => {
  return await request.post(`/account/register`,
    {
      account_name: formData.account_name,
      email: formData.email,
      password: formData.password,
      phone_number: formData.phone_number,
    }
  );
};

const forgotPasswordApi = async (formData) => {
  return await request.post(`/account/forgot-password`, formData);
};

const resetPasswordApi = async (token, formData) => {
  try {
    return await axios({
      baseURL: `${baseURLApi}/account/reset-password`,
      method: 'PATCH',
      headers: {
        'token': token
      },
      data: formData
    });
  } catch (error) {
    ShowToast("error", 'Đổi mật khẩu thất bại, kiểm tra lại đường dẫn trong email!')
  }
};

const updateAccountApi = async (formData) => {
  return await requestJWT.put(`/account/update`, formData);
};

const refreshToken = async (formData) => {
  const res = await request.post(`/account/refresh`, formData);
  return res.data;
};

const getAllStaffApi = async (query, page, permission) => {
  return await requestJWT.get(`/account/get-staff?query=${query}&permission=${permission}&page=${page}&item=5`);
};

const createStaffApi = async (formData) => {
  return await requestJWT.post(`/account/create`, formData);
};

const updateStaffApi = async (id, formData) => {
  return await requestJWT.put(`/account/admin/${id}/update`, formData);
};

const removeStaffApi = async (id) => {
  return await requestJWT.delete(`/account/${id}/remove`);
};

const changePasswordApi = async (data) => {
  return await requestJWT.patch(`/account/change-password`, {
    current_password: data.current_password,
    new_password: data.new_password
  });
};

const getAllCustomerApi = async (query, sex, page) => {
  return await requestJWT.get(`/account/get-customer?query=${query}&sex=${sex}&page=${page}&item=5`);
};

const getAllCustomerSelectApi = async () => {
  return await requestJWT.get(`/account/get-customer-select`);
};

const getAllStaffSelectApi = async () => {
  return await requestJWT.get(`/account/get-staff-select`);
};

export {
  loginApi,
  registerApi,
  forgotPasswordApi,
  resetPasswordApi,
  updateAccountApi,
  refreshToken,
  getInfoApi,
  getAllStaffApi,
  createStaffApi,
  updateStaffApi,
  removeStaffApi,
  changePasswordApi,
  getAllCustomerApi,
  getAllCustomerSelectApi,
  getAllStaffSelectApi
};
